(function () {
  function track(name, context) {
    if (window.PxmAnalytics && typeof window.PxmAnalytics.track === 'function') {
      window.PxmAnalytics.track(name, context || {});
    }
  }
  const eventLabels = {
    OBSERVATION: 'Observation', REPOTTING: 'Rempotage', MOVED: 'Changement de place',
    TREATMENT: 'Traitement', PHOTO: 'Photo', NOTE: 'Note'
  };

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
    }[character]));
  }

  function dateLabel(value) {
    if (!value) return '';
    return new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(value));
  }

  function dateInput(value) {
    return value ? new Date(value).toISOString().slice(0, 10) : '';
  }

  function isoFromDate(value) {
    return value ? new Date(`${value}T12:00:00`).toISOString() : null;
  }

  function normalized(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }

  function init(root) {
    if (!root || root.dataset.pxmReady) return;
    root.dataset.pxmReady = 'true';
    const api = window.PXMAccount;
    const grid = root.querySelector('[data-pxm-garden-grid]');
    if (!grid || !api) return;
    const loading = root.querySelector('[data-pxm-garden-loading]');
    const empty = root.querySelector('[data-pxm-garden-empty]');
    const noResults = root.querySelector('[data-pxm-garden-no-results]');
    const count = root.querySelector('[data-pxm-garden-count]');
    const plural = root.querySelector('[data-pxm-garden-plural]');
    const readCount = root.querySelector('[data-pxm-read-count]');
    const readPlurals = root.querySelectorAll('[data-pxm-read-plural], [data-pxm-read-plural-f]');
    const eventCount = root.querySelector('[data-pxm-event-count]');
    const eventPlural = root.querySelector('[data-pxm-event-plural]');
    const search = root.querySelector('[data-pxm-garden-search]');
    const results = root.querySelector('[data-pxm-garden-results]');
    const sync = root.querySelector('[data-pxm-garden-sync]');
    const addPanel = root.querySelector('[data-pxm-garden-add-panel]');
    const addForm = root.querySelector('[data-pxm-garden-add-form]');
    const plantDialog = root.querySelector('[data-pxm-plant-dialog]');
    const plantDialogContent = root.querySelector('[data-pxm-plant-dialog-content]');
    let plants = [];
    let reading = {};
    let query = '';
    let selectedPlantId = null;

    function imageMarkup(plant) {
      if (plant.coverImageUrl) return `<img src="${escapeHtml(plant.coverImageUrl)}" alt="${escapeHtml(plant.nickname)}" loading="lazy" width="720" height="720">`;
      return '<span class="pxm-garden-card__placeholder" aria-hidden="true">⌁</span>';
    }

    function eventImageMarkup(event) {
      return event.imageUrl ? `<img src="${escapeHtml(event.imageUrl)}" alt="" loading="lazy" width="240" height="240">` : '';
    }

    function journalMarkup(plant) {
      const events = (plant.events || []).slice(0, 5);
      if (!events.length) return '<p class="pxm-garden-journal__empty">Le journal est encore vide.</p>';
      return `<ol class="pxm-garden-journal">${events.map((item) => `
        <li>
          ${eventImageMarkup(item)}
          <div><span>${escapeHtml(eventLabels[item.type] || 'Suivi')} · ${dateLabel(item.occurredAt)}</span>${item.note ? `<p>${escapeHtml(item.note)}</p>` : ''}</div>
        </li>`).join('')}</ol>`;
    }

    function fileFieldMarkup(label) {
      return `<label class="pxm-garden-file">
        <span>${label}</span>
        <span class="pxm-garden-file__control"><span class="pxm-garden-file__button">Choisir une photo</span><small data-pxm-file-name>Aucune photo choisie</small></span>
        <input class="visually-hidden" name="photo" type="file" accept="image/jpeg,image/png,image/webp" data-pxm-file-input>
      </label>`;
    }

    function completeJournalMarkup(plant) {
      const events = plant.events || [];
      if (!events.length) return '<div class="pxm-garden-dialog__empty"><strong>Le journal commence ici.</strong><p>Ajoutez une observation, une photo ou un changement important.</p></div>';
      return `<ol class="pxm-garden-timeline">${events.map((item) => `
        <li>
          <span class="pxm-garden-timeline__dot" aria-hidden="true"></span>
          <div class="pxm-garden-timeline__content">
            <div><strong>${escapeHtml(eventLabels[item.type] || 'Suivi')}</strong><time>${dateLabel(item.occurredAt)}</time></div>
            ${item.note ? `<p>${escapeHtml(item.note)}</p>` : ''}
            ${eventImageMarkup(item)}
          </div>
        </li>`).join('')}</ol>`;
    }

    function renderPlantDialog(plant) {
      if (!plantDialogContent || !plant) return;
      selectedPlantId = plant.id;
      plantDialogContent.innerHTML = `
        <header class="pxm-garden-dialog__hero">
          <div class="pxm-garden-dialog__image">${imageMarkup(plant)}</div>
          <div>
            <p class="pxm-v14-eyebrow">Fiche de plante</p>
            <h2 id="pxm-garden-dialog-title">${escapeHtml(plant.nickname)}</h2>
            <p class="pxm-garden-dialog__botanical">${escapeHtml(plant.botanicalName || 'Nom botanique à compléter')}</p>
            <div class="pxm-garden-plant__facts">
              ${plant.acquiredAt ? `<span>Arrivée le ${dateLabel(plant.acquiredAt)}</span>` : '<span>Date d’arrivée à compléter</span>'}
              <span>${(plant.events || []).length} suivi${(plant.events || []).length === 1 ? '' : 's'}</span>
            </div>
            ${plant.notes ? `<p class="pxm-garden-dialog__note">${escapeHtml(plant.notes)}</p>` : ''}
            <div class="pxm-garden-dialog__export">
              <button type="button" class="pxm-v14-button" data-pxm-export-plant>Télécharger la fiche PDF</button>
              <span data-pxm-export-status role="status" aria-live="polite"></span>
            </div>
          </div>
        </header>
        <div class="pxm-garden-dialog__body">
          <section class="pxm-garden-dialog__history" aria-labelledby="pxm-garden-history-title">
            <div class="pxm-garden-dialog__section-head"><p class="pxm-v14-eyebrow">Historique</p><h3 id="pxm-garden-history-title">Le journal de ${escapeHtml(plant.nickname)}</h3></div>
            ${completeJournalMarkup(plant)}
          </section>
          <aside class="pxm-garden-dialog__aside">
            <details class="pxm-garden-card-panel pxm-garden-event" open>
              <summary>Ajouter un suivi <span aria-hidden="true">＋</span></summary>
              <form data-pxm-event-form>
                <div class="pxm-garden-form-row"><label>Type<select name="type"><option value="OBSERVATION">Observation</option><option value="PHOTO">Photo</option><option value="REPOTTING">Rempotage</option><option value="MOVED">Changement de place</option><option value="TREATMENT">Traitement</option><option value="NOTE">Note</option></select></label><label>Date<input name="occurredAt" type="date" value="${new Date().toISOString().slice(0, 10)}"></label></div>
                <label>Ce que vous retenez<textarea name="note" maxlength="3000" rows="3"></textarea></label>
                ${fileFieldMarkup('Photo facultative')}
                <p class="pxm-garden-form-error" data-pxm-form-error role="alert" hidden></p>
                <button type="submit">Enregistrer ce suivi</button>
              </form>
            </details>
            <details class="pxm-garden-card-panel pxm-garden-edit">
              <summary>Modifier les informations <span aria-hidden="true">↓</span></summary>
              <form data-pxm-edit-form>
                <label>Son petit nom<input name="nickname" required maxlength="100" value="${escapeHtml(plant.nickname)}"></label>
                <label>Nom botanique<input name="botanicalName" maxlength="160" value="${escapeHtml(plant.botanicalName)}"></label>
                <label>Date d’arrivée<input name="acquiredAt" type="date" value="${dateInput(plant.acquiredAt)}"></label>
                <label>Note principale<textarea name="notes" maxlength="3000" rows="3">${escapeHtml(plant.notes)}</textarea></label>
                ${fileFieldMarkup('Remplacer la photo')}
                <p class="pxm-garden-form-error" data-pxm-form-error role="alert" hidden></p>
                <div class="pxm-garden-edit__footer"><button type="submit">Enregistrer</button><button class="pxm-garden-archive" type="button" data-pxm-archive>Retirer du Jardin</button></div>
              </form>
            </details>
          </aside>
        </div>`;
    }

    function render() {
      if (loading) loading.hidden = true;
      const totalEvents = plants.reduce((total, plant) => total + (plant.events || []).length, 0);
      const totalRead = Array.isArray(reading.readIds) ? reading.readIds.length : 0;
      const visiblePlants = query ? plants.filter((plant) => normalized(`${plant.nickname} ${plant.botanicalName}`).includes(query)) : plants;

      if (count) count.textContent = String(plants.length);
      if (plural) plural.hidden = plants.length === 1;
      if (readCount) readCount.textContent = String(totalRead);
      readPlurals.forEach((marker) => { marker.hidden = totalRead === 1; });
      if (eventCount) eventCount.textContent = String(totalEvents);
      if (eventPlural) eventPlural.hidden = totalEvents === 1;
      if (empty) empty.hidden = plants.length > 0;
      if (noResults) noResults.hidden = plants.length === 0 || visiblePlants.length > 0;
      if (results) results.textContent = query ? `${visiblePlants.length} résultat${visiblePlants.length === 1 ? '' : 's'} sur ${plants.length}` : '';

      grid.replaceChildren();
      visiblePlants.forEach((plant) => {
        const lastEvent = plant.events && plant.events[0];
        const article = document.createElement('article');
        article.className = 'pxm-garden-plant';
        article.dataset.plantId = plant.id;
        article.innerHTML = `
          <button class="pxm-garden-plant__image" type="button" data-pxm-open-plant aria-label="Ouvrir la fiche de ${escapeHtml(plant.nickname)}">${imageMarkup(plant)}</button>
          <div class="pxm-garden-plant__body">
            <div class="pxm-garden-plant__heading">
              <div><p class="pxm-garden-plant__meta">${escapeHtml(plant.botanicalName || 'Plante de ma collection')}</p><button class="pxm-garden-plant__title" type="button" data-pxm-open-plant><h3>${escapeHtml(plant.nickname)}</h3></button></div>
              <span>${(plant.events || []).length} suivi${(plant.events || []).length === 1 ? '' : 's'}</span>
            </div>
            <div class="pxm-garden-plant__facts">
              ${plant.acquiredAt ? `<span>Arrivée le ${dateLabel(plant.acquiredAt)}</span>` : '<span>Date d’arrivée à compléter</span>'}
            </div>
            <p class="pxm-garden-plant__latest">${lastEvent ? `<strong>${escapeHtml(eventLabels[lastEvent.type] || 'Suivi')} · ${dateLabel(lastEvent.occurredAt)}</strong>${lastEvent.note ? `<br>${escapeHtml(lastEvent.note)}` : ''}` : plant.notes ? `<strong>Première note</strong><br>${escapeHtml(plant.notes)}` : 'Aucune observation pour le moment.'}</p>
            <button class="pxm-garden-plant__open" type="button" data-pxm-open-plant>Voir la fiche et l’historique <span aria-hidden="true">→</span></button>
          </div>`;
        grid.appendChild(article);
      });
    }

    function setError(form, error) {
      const target = form.querySelector('[data-pxm-form-error]');
      if (!target) return;
      target.textContent = error && error.message || 'Une erreur est survenue.';
      target.hidden = false;
    }

    async function optimizeImage(file) {
      if (!file || file.size < 900000 || typeof createImageBitmap !== 'function') return file;
      try {
        const bitmap = await createImageBitmap(file);
        const longestSide = Math.max(bitmap.width, bitmap.height);
        const scale = Math.min(1, 1600 / longestSide);
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(bitmap.width * scale);
        canvas.height = Math.round(bitmap.height * scale);
        canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        bitmap.close();
        const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/webp', .82));
        if (!blob || blob.size >= file.size) return file;
        return new File([blob], `${file.name.replace(/\.[^.]+$/, '')}.webp`, { type: 'image/webp' });
      } catch (error) {
        return file;
      }
    }

    async function uploadFrom(form) {
      const file = form.elements.photo && form.elements.photo.files[0];
      return file ? api.uploadImage(await optimizeImage(file)) : null;
    }

    async function safeUploadFrom(form) {
      try { return { imageUrl: await uploadFrom(form), error: null }; }
      catch (error) { return { imageUrl: null, error }; }
    }

    function setBusy(button, busy, busyLabel) {
      if (!button) return;
      if (busy) {
        button.dataset.pxmOriginalLabel = button.textContent;
        button.textContent = busyLabel;
        button.setAttribute('aria-busy', 'true');
      } else {
        button.textContent = button.dataset.pxmOriginalLabel || button.textContent;
        button.removeAttribute('aria-busy');
      }
      button.disabled = busy;
    }

    addForm && addForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = addForm.querySelector('[type="submit"]');
      setBusy(button, true, 'Ajout en cours…');
      const error = addForm.querySelector('[data-pxm-form-error]');
      if (error) error.hidden = true;
      try {
        const pendingPhoto = addForm.elements.photo && addForm.elements.photo.files[0];
        const plant = await api.addPlant({
          nickname: addForm.elements.nickname.value,
          botanicalName: addForm.elements.botanicalName.value || null,
          acquiredAt: isoFromDate(addForm.elements.acquiredAt.value),
          coverImageUrl: null,
          notes: addForm.elements.notes.value || null,
          source: 'MANUAL'
        });
        track('garden_plant_added', { source: 'manual' });
        addForm.reset();
        addPanel.hidden = true;
        if (pendingPhoto) {
          if (sync) sync.textContent = 'Votre plante est ajoutée · photo en cours…';
          try {
            const imageUrl = await api.uploadImage(await optimizeImage(pendingPhoto));
            await api.updatePlant(plant.id, { coverImageUrl: imageUrl });
          } catch (photoError) {
            window.alert(`La plante a bien été ajoutée, mais sa photo n’a pas pu être enregistrée : ${photoError.message}`);
          } finally {
            if (sync) sync.textContent = 'Synchronisé avec votre compte';
          }
        }
      } catch (submitError) { setError(addForm, submitError); }
      finally { setBusy(button, false); }
    });

    root.addEventListener('submit', async (event) => {
      const eventForm = event.target.closest('[data-pxm-event-form]');
      const editForm = event.target.closest('[data-pxm-edit-form]');
      if (!eventForm && !editForm) return;
      event.preventDefault();
      const form = eventForm || editForm;
      const plantId = form.closest('[data-plant-id]')?.dataset.plantId || selectedPlantId;
      const button = form.querySelector('[type="submit"]');
      setBusy(button, true, eventForm ? 'Enregistrement…' : 'Mise à jour…');
      const error = form.querySelector('[data-pxm-form-error]');
      if (error) error.hidden = true;
      try {
        const photo = await safeUploadFrom(form);
        if (eventForm) {
          await api.addEvent(plantId, {
            type: form.elements.type.value,
            occurredAt: isoFromDate(form.elements.occurredAt.value),
            note: form.elements.note.value || null,
            imageUrl: photo.imageUrl
          });
          track('garden_observation_added', { event_type: form.elements.type.value });
          form.reset();
          if (photo.error) window.alert(`Le suivi a bien été enregistré, mais sa photo n’a pas pu être ajoutée : ${photo.error.message}`);
        } else {
          const currentPlant = plants.find((plant) => plant.id === plantId);
          await api.updatePlant(plantId, {
            nickname: form.elements.nickname.value,
            botanicalName: form.elements.botanicalName.value || null,
            acquiredAt: isoFromDate(form.elements.acquiredAt.value),
            notes: form.elements.notes.value || null,
            coverImageUrl: photo.imageUrl || currentPlant.coverImageUrl || null
          });
          if (photo.error) window.alert(`Les informations ont bien été enregistrées, mais la nouvelle photo n’a pas pu être ajoutée : ${photo.error.message}`);
        }
      } catch (submitError) { setError(form, submitError); }
      finally { setBusy(button, false); }
    });

    root.addEventListener('click', async (event) => {
      if (event.target.closest('[data-pxm-close-add]')) {
        addPanel.hidden = true;
        return;
      }

      const openButton = event.target.closest('[data-pxm-open-plant]');
      if (openButton) {
        const card = openButton.closest('[data-plant-id]');
        const plant = plants.find((item) => item.id === card.dataset.plantId);
        renderPlantDialog(plant);
        if (plantDialog && !plantDialog.open) plantDialog.showModal();
        return;
      }

      if (event.target.closest('[data-pxm-close-plant]')) {
        plantDialog?.close();
        return;
      }

      const exportButton = event.target.closest('[data-pxm-export-plant]');
      if (exportButton) {
        const plant = plants.find((item) => item.id === selectedPlantId);
        const status = plantDialogContent.querySelector('[data-pxm-export-status]');
        if (!plant || !window.PxmPdfDownload) return;
        setBusy(exportButton, true, 'Création du PDF…');
        if (status) status.textContent = 'Préparation de la fiche et de son historique…';
        try {
          await window.PxmPdfDownload.download('/api/pdf/garden', {
            plantId: plant.id,
            sourceUrl: window.location.origin + window.location.pathname + window.location.search
          }, 'plant-x-me-jardin.pdf');
          if (status) status.textContent = 'Fiche téléchargée.';
          track('pdf_download', { pdf_type: 'garden' });
        } catch (pdfError) {
          if (status) status.textContent = pdfError.message || 'Le PDF n’a pas pu être créé.';
        } finally {
          setBusy(exportButton, false);
        }
        return;
      }

      const button = event.target.closest('[data-pxm-archive]');
      if (!button) return;
      const card = button.closest('[data-plant-id]');
      const plantId = card?.dataset.plantId || selectedPlantId;
      const plant = plants.find((item) => item.id === plantId);
      if (!window.confirm(`Retirer « ${plant.nickname} » du Jardin ? Son historique sera conservé.`)) return;
      button.disabled = true;
      try { await api.updatePlant(plant.id, { archived: true }); plantDialog?.close(); }
      catch (archiveError) { window.alert(archiveError.message); button.disabled = false; }
    });

    plantDialog?.addEventListener('click', (event) => {
      if (event.target === plantDialog) plantDialog.close();
    });

    root.addEventListener('change', (event) => {
      const input = event.target.closest('[data-pxm-file-input]');
      if (!input) return;
      const name = input.closest('.pxm-garden-file')?.querySelector('[data-pxm-file-name]');
      if (name) name.textContent = input.files[0] ? input.files[0].name : 'Aucune photo choisie';
    });

    root.querySelectorAll('[data-pxm-open-add]').forEach((button) => button.addEventListener('click', () => {
      addPanel.hidden = false;
      addPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => addForm.elements.nickname.focus(), 350);
    }));

    search && search.addEventListener('input', () => {
      query = normalized(search.value);
      render();
    });

    function receiveState(state) {
      plants = state.garden || [];
      reading = state.reading || {};
      if (sync) sync.textContent = 'Synchronisé avec votre compte';
      render();
      if (plantDialog?.open && selectedPlantId) {
        const selectedPlant = plants.find((plant) => plant.id === selectedPlantId);
        if (selectedPlant) renderPlantDialog(selectedPlant);
        else plantDialog.close();
      }
    }

    window.addEventListener('pxm:account-state', (event) => receiveState(event.detail));
    window.addEventListener('pxm:account-ready', (event) => {
      if (!event.detail.connected && event.detail.reason === 'error') {
        if (loading) loading.textContent = 'Le Jardin est momentanément indisponible. Vos données sont conservées.';
        if (sync) sync.textContent = 'Synchronisation indisponible';
      }
    });

    api.ready.then((state) => { if (state) receiveState(state); });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pxm-garden-root]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
